import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import styles from "./BlogDetail.module.scss";

import { SingleBanner, Loader } from "../../../library/common";
import { BlogContent, BlogTopBar } from "../../../library/component";
import MetaTag from "../../../library/meta";

import { axiosInstance } from "../../../services";

const BlogDetail = () => {
  const { id } = useParams();
  const {
    i18n: { language },
  } = useTranslation();
  const [blogDetail, setBlogDetail] = useState("");
  const [loader, setLoader] = useState(true);
  const fetchBlogDetail = async (id) => {
    setLoader(true);
    try {
      const res = await axiosInstance.get(`/blogs/${id}`);
      if (res?.data) {
        const {
          coverImage = "",
          title = "",
          publishDate = "",
          author,
          socialMediaLinks = {},
          longDescription = "",
          shortDescription = "",
          metafields = {},
        } = res?.data || {};

        const transformedData = {
          coverImage,
          title,
          publishedDate: publishDate,
          authors: author ? [author] : [],
          socialMediaLinks,
          longDescription,
          shortDescription,
          tags: metafields.tags || [],
          relateds: [],
          metaTitle: metafields?.title || "",
          metaDescription: metafields?.description || "",
          featuredImage: metafields?.image || "",
        };

        setBlogDetail(transformedData);
      }
    } catch (error) {
      console.error("Error fetching blog details:", error);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (!blogDetail) {
      setLoader(true);
      fetchBlogDetail(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  const currentUrl = window.location.href;
  if (loader) {
    return <Loader />;
  }
  return (
    <main className={styles.blogContainer}>
      {blogDetail ? (
        <MetaTag
          title={blogDetail?.metaTitle || blogDetail?.title?.title || ""}
          description={
            blogDetail?.metaDescription ||
            blogDetail?.description[language] ||
            ""
          }
          img={blogDetail?.featuredImage || blogDetail?.coverImage || ""}
          url={currentUrl}
        />
      ) : null}
      <div className={styles.bannerWrapper}>
        <SingleBanner {...blogDetail} />
        <BlogTopBar {...blogDetail} path="blog" />
        <BlogContent {...blogDetail} />
      </div>
    </main>
  );
};
export default BlogDetail;
